module.exports = __webpack_public_path__ + "assets/img/d4.0ade7ab4.jpg";